import { render, staticRenderFns } from "./addconsulting.vue?vue&type=template&id=37a6626d&"
import script from "./addconsulting.vue?vue&type=script&lang=js&"
export * from "./addconsulting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\project_nav_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a6626d')) {
      api.createRecord('37a6626d', component.options)
    } else {
      api.reload('37a6626d', component.options)
    }
    module.hot.accept("./addconsulting.vue?vue&type=template&id=37a6626d&", function () {
      api.rerender('37a6626d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/consulting/components/addconsulting.vue"
export default component.exports